<template>
  <div v-loading="$wait.waiting(_uid)" class="max-w-screen-md m-auto mt-10">
    <alert :type="'info'" :icon="'far fa-hourglass'"> Please wait... </alert>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Alert from "../../../UIComponents/Alert.vue";

export default {
  components: { Alert },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    routeParams() {
      return this.$route.params;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  async mounted() {
    this.$wait.start(this._uid);
    setTimeout(() => {
      try {
        if (this.routeQuery.training === "training") {
          return this.$router.push({
            name: "my@training",
          });
        }
        return this.$router.push({
          name: "home",
        });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    }, 3000);
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
  },
};
</script>
<style lang="scss" scoped></style>
